import { zipFileTypes } from '../data/BomFileTypes';

import {
  hasValidPartSupplierSelections,
  hasValidSelectedPartSupplier,
  valid_buy_options
} from "./helpers";

const MAX_DESCRIPTION_LENGTH = 250

const calculate_qty_by_reference_designator = (reference_designator, separator = ",", range_separator = "-") => {
  let qty_calculated = 0
  if (!reference_designator) return qty_calculated
  const match_regex = new RegExp(`\D*\d*${range_separator}\D*\d*`, "i")
  const reference_designators = reference_designator.split(separator)
  reference_designators.forEach((reference_designator) => {
    if (reference_designator.match(match_regex)) {
      const regex = /([A-Za-z]+)(\d+)-([A-Za-z]+)(\d+)/;
      const range = reference_designator.match(regex)

      if (range && range.length > 1) {
        const start = parseInt(range[1], 10)
        const end = parseInt(range[3], 10)
        qty_calculated += (end - start) + 1
      }
    } else {
      qty_calculated += 1
    }
  })
  return qty_calculated
}

const isValidBomLineItem = (bom_line_item) => {
  const identifier = bom_line_item["mpn"]
  return identifier && identifier != ""
}

export const buildBomLineItems = (bom_parameters, workbook, first_row) => {
  let bom_line_items = []
  let registry = {}
  workbook.map((row, idx) => {
    return { row, 'line_in_file': (idx + 1) }
  }).slice(first_row - 1).forEach((data) => {
    let bom_line_item = {}
    const { row, line_in_file } = data
    bom_parameters.forEach((param, index) => {
      let value = row[index]
      let key = ""
      if (param == "reference_designator") key = "reference_designator"
      if (param == "manufacturer") key = "manufacturer"
      if (param == "vendor") key = "distributor"
      if (param == "description") {
        key = "description"
        if (value && typeof value == "string" && value != "" && value.length > MAX_DESCRIPTION_LENGTH) value = value.substring(0, MAX_DESCRIPTION_LENGTH) + "..."
      }
      if (param == "dnp") {
        key = "dnp"
        if (typeof value == "number") {
          value = value === 1
        } else if (typeof value === "string" && value !== "") {
          const trimmed = value.trim()
          if (typeof trimmed.test === 'function') {
            value = trimmed.test(/(true|t|yes|y|1)$/i)
          } else {
            value = false
          }
        } else {
          value = false
        }
      }
      if (param == "mpn" || param == "vendor_part") {
        if(typeof value == "number") value = value.toString()
        else if ( value && typeof value === "string" && value !== "") value = value.trim()
        else value = ""
        if (param == "mpn") {
          key = "mpn"
          bom_line_item["original_mpn"] = value
        }
        if (param == "vendor_part") key = "distributor_part_number"
      }
      if (param == "qty_per_board") {
        key = "qty"
        value = parseInt(value)
      }
      if (key != "") bom_line_item[key] = value
    })

    if (isValidBomLineItem(bom_line_item)) {
      bom_line_item["line_in_file"] = line_in_file
      let identifier = bom_line_item["mpn"]
      if (!registry[identifier]) registry[identifier] = { count: 0, duplicates: [] }
      registry[identifier].count += 1
      if (registry[identifier].count > 1) registry[identifier].duplicates.push(bom_line_item)
      else bom_line_items.push(bom_line_item)
    }
  })

  return bom_line_items.map((bom_line_item) => {
    let identifier = bom_line_item["mpn"]
    if (registry[identifier].count > 1) {
      registry[identifier].duplicates.forEach((duplicate) => {
        if (bom_line_item["qty"]) bom_line_item["qty"] += duplicate["qty"]
        if (bom_line_item["reference_designator"]) {
          const separator = bom_line_item["reference_designator"].endsWith(",") ? "" : ","
          bom_line_item["reference_designator"] += `${separator}${duplicate["reference_designator"]}`
        }
      })
    }
    if (bom_line_item["reference_designator"]) {
      bom_line_item["qty_calculated"] = calculate_qty_by_reference_designator(bom_line_item["reference_designator"])
      if (!bom_line_item["qty"]) bom_line_item["qty"] = bom_line_item["qty_calculated"]
    }
    bom_line_item["_new"] = true
    return bom_line_item
  })
}

export const buildBomData = (bom) => {
  const { id, name, revision, board_qtys, selected_board_qty, totals, base_totals, markups, shipping, tariffs, bom_line_items } = bom
  return {
    id, name, revision, board_qtys, selected_board_qty, totals, base_totals, markups, shipping, tariffs,
    bom_line_items: bom_line_items.map((bli) => buildBomLineItemData(bli, board_qtys))
  }
}

export const buildBomLineItemData = (bom_line_item, board_qtys) => {
  const {
    id, mpn, original_mpn, reference_designator, qty, distributor_part_number, manufacturer,
    description, quote_status, user_action, status, extra_parts, qty_to_buy, price_by_qty,
    calculated_minimun_order_qty, line_in_file, selected_part,
  } = bom_line_item

  return {
    id, mpn, original_mpn, reference_designator, qty, distributor_part_number, manufacturer,
    description, quote_status, user_action, status, extra_parts, qty_to_buy, price_by_qty,
    calculated_minimun_order_qty, line_in_file, selected_part: buildPartData(selected_part, board_qtys, user_action)
  }
}

export const buildPartData = (part, board_qtys, user_action) => {
  if (!valid_buy_options.includes(user_action)) return {}
  const { id, mpn, extra_parts, manufacturer, mounting_type, package_case, selected_part_supplier, ps_selections } = part
  let sp_data = { id, mpn, manufacturer, mounting_type, package_case, extra_parts, selected_part_supplier: {}, ps_selections: {} }
  board_qtys.forEach((board_qty) => {
    if (hasValidPartSupplierSelections(part, board_qty)) {
      if (!sp_data.ps_selections[board_qty]) sp_data.ps_selections[board_qty] = []
      ps_selections[board_qty].forEach((ps) => sp_data.ps_selections[board_qty].push(buildPartSupplierData(ps, board_qty)))
    } else if (hasValidSelectedPartSupplier(part, board_qty)) {
      sp_data.selected_part_supplier[board_qty] = buildPartSupplierData(selected_part_supplier[board_qty], board_qty)
    }
  })
  return sp_data
}

export const buildPartSupplierData = (part_supplier, board_qty) => {
  const {
    id, partnumber, description, stock, moq, markup, part_status,
    supplier, pricebreaks, selected_pricebreak, qty_to_buy, taxes,
  } = part_supplier

  let ps_data = {
    id,
    partnumber,
    description,
    stock,
    moq,
    markup,
    part_status,
    qty_to_buy,
    supplier: buildSupplierData(supplier),
    pricebreaks: pricebreaks.map((pb) => buildPricebreakData(pb)),
    taxes: taxes.map((tax) => buildTaxData(tax)),
    selected_pricebreak: {
      [board_qty]: buildPricebreakData(selected_pricebreak[board_qty])
    },

  }
  return ps_data
}

export const buildPricebreakData = (pricebreak) => {
  const { id, price, qty, packaging } = pricebreak
  return { id, price, qty, packaging }
}

export const buildSupplierData = (supplier) => {
  const { id, name, code } = supplier
  return { id, name, code }
}

export const buildTaxData = (tax) => {
  const { id, name, percentage, amount, included_in_price } = tax
  return { id, name, percentage, amount, included_in_price }
}

export const buildBomFormData = (arg) => {
  if (!arg) return null;

  const {
    bom,
    project_number,
    project_reference,
  } = arg;

  const {
    bom_file,
    bomPartNumber,
    bomProductQuoteNumber,
    bomRevision,
    bomSaved,
    bomVariant,
    mainProductInputFileId,
  } = bom

  if (!bomSaved) return null;

  let form = new FormData();
  form.append('variant_id', bomVariant);
  form.append('parameters[project_number]', project_number);
  form.append('parameters[project_reference]', project_reference);
  form.append('parameters[product_quote_number]', bomProductQuoteNumber);
  form.append('parameters[part_number]', bomPartNumber);
  form.append('parameters[revision]', bomRevision);

  let file = $(`#${mainProductInputFileId}`).prop("files")[0]
  if (file && zipFileTypes.includes(file.type)) {
    form.append('parameters[filename]', file);
    form.append('parameters[bom_file]', bom_file);
  }

  return form;
}

export const buildDataForBomDestroy = (args) => {
  if (!args || !args.destroy || !args.line_item_id) return [];
  return [args.line_item_id]
}

export const buildForms = (args) => {
  if (!args) return [];

  const { bom, project_number, project_reference } = args;
  if (!bom) return [];

  const bom_form = buildBomFormData({ bom, project_number, project_reference });
  return bom_form ? [bom_form] : [];
}